import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { APIURL } from "../../../Config";
import axios from "axios";
import moment from "moment/moment";

import { toast } from "react-toastify";

function FinancierSupport() {
  const emailid = localStorage.getItem("emailId");
  const token = localStorage.getItem("token");

  console.log("emailsupport::::", emailid);

  const [isLoader, setIsLoader] = useState(false);

  const [supportModel, setSupportModel] = useState(false);
  const [openSupport, setOpenSupport] = useState(0);

  const [issue, setIssue] = useState([]);
  useEffect(() => {
    EmployerIssueList();
  }, []);

  const EmployerIssueList = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/audit/${emailid}/Employer`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIssue(response?.data);
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const openSupportModel = (value) => {
    setSupportModel(true);
    setOpenSupport(value);
  };

  const validationSchema = Yup.object({
    issue: Yup.string().required("Issue is required"),
    mobile: Yup.string()
      .required("Required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
  });

  // Initial form values
  const initialValues = {
    issue: "",
    mobile: "",
  };

  return (
    <div className="p-md-3 pt-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Support
            </button>
          </li>
        </ul>
      </div>
      <div className="pt-3">
        <div className="card">
          <div className="p-3 pt-4">
            <div className="d-flex justify-content-end mb-3">
              <div>
                {!supportModel ? (
                  <button
                    className="btn btn-success mb-3 mb-md-0 w-auto"
                    style={{ width: "120px", backgroundColor: "#66a725" }}
                    onClick={() => openSupportModel(1)}
                  >
                    Raise Query
                  </button>
                ) : (
                  <button
                    className="btn btn-secondary mb-3 mb-md-0"
                    style={{ width: "120px" }}
                    onClick={() => {
                      // getAccountList();
                      setSupportModel(false);
                    }}
                  >
                    Back
                  </button>
                )}
              </div>
            </div>
            {supportModel ? (
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { resetForm }) => {
                  console.log("values::", values);
                  setIsLoader(true);
                  const data = {
                    ...values,
                    email: emailid,
                    ownerEmail: emailid,
                    user: "Financier",
                  };
                  axios
                    .request(`${APIURL}/support`, {
                      method: "POST",
                      data: data,
                      headers: {
                        Authentication: token,

                        "Content-Type": "application/json",
                      },
                    })
                    .then((response) => {
                      console.log("response:::", response);
                      toast.success(response.data);
                      setIsLoader(false);
                      resetForm();
                    })
                    .catch((error) => {
                      setIsLoader(false);
                      console.log(error);
                      resetForm();
                    });
                }}
              >
                {() => (
                  <Form>
                    {/* Issue field */}
                    <div className="form-group">
                      <label htmlFor="issue">Issue</label>
                      <Field
                        as="textarea"
                        rows="5"
                        id="issue"
                        name="issue"
                        className="form-control"
                        placeholder="Enter your issue"
                      />
                      <ErrorMessage
                        name="issue"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* Mobile field */}
                    <div className="form-group">
                      <label htmlFor="mobile">Mobile</label>
                      <Field
                        type="number"
                        id="mobile"
                        name="mobile"
                        className="form-control"
                        placeholder="Enter your mobile number"
                      />
                      <ErrorMessage
                        name="mobile"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    {/* Submit button */}
                    <button type="submit" className="btn btn-success mt-3">
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </Form>
                )}
              </Formik>
            ) : isLoader ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Entry dt</th>
                        <th style={{ textAlign: "center" }}>Entry time</th>
                        <th style={{ textAlign: "center" }}>
                          Employer name/Code
                        </th>
                        <th style={{ textAlign: "center" }}>Contact name</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>Issue</th>
                        <th style={{ textAlign: "center" }}>
                          Resolution remark by us
                        </th>
                        <th style={{ textAlign: "center" }}>Ticket Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {issue &&
                        issue?.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.date
                                ? moment(item.date).format("DD-MM-YYYY")
                                : ""}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {" "}
                              {item.time
                                ? moment(item.time).format("HH:mm:ss")
                                : ""}
                            </td>
                            <td>
                              {item.empName}/{item.code}
                            </td>
                            <td>{item.contactName}</td>
                            <td>{item.mobile}</td>
                            <td>{item.issue}</td>
                            <td>{item.remarks}</td>
                            <td>{item.status}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinancierSupport;
